import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { LoginComponent } from './login/login.component';
import { PasswordComponent } from './password/password.component';
import { ActivateService, AuthGuardService } from './services/activate.service';

export const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuardService], // 認証ガード
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth/member'
      },
      {
        path: 'home',
        redirectTo: 'auth/member',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        redirectTo: 'auth/member',
        pathMatch: 'full'
      },
      {
        path: 'auth',
        canActivate: [ActivateService],
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: 'shop',
        canActivate: [ActivateService],
        loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
      },
      {
        path: 'fdcp',
        canActivate: [ActivateService],
        loadChildren: () => import('./fdcp/fdcp.module').then(m => m.FdcpModule)
      },
      {
        path: 'password',
        component: PasswordComponent
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    enableTracing: true  // デバッグ用: コンソールにルーティングログ出力
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
